var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Sur3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 82,
    viewBox: "0 0 77 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3778 21.6317C40.7677 17.6859 31.7773 21.8144 28.2333 24.3719C26.4524 25.6571 24.6313 30.4261 21.9454 34.375C18.588 39.3111 9.20793 45.2009 17.0419 56.7096C24.8759 68.2182 42.7821 66.5741 55.0927 58.9017C67.4032 51.2292 70.7607 35.3363 62.3671 32.5962C53.9736 29.856 57.8905 26.564 48.3778 21.6317Z",
    fill: "#CDE3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6458 29.2499C55.1402 26.5097 55.4685 18.851 51.3791 12.1437C47.2898 5.43636 40.3313 2.2203 35.8369 4.96043C31.3426 7.70056 31.0143 15.3592 35.1037 22.0666C39.193 28.7739 46.1515 31.99 50.6458 29.2499Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M51.9061 28.255C48.1652 32.0809 41.2481 30.1967 36.4627 24.0443C31.6772 17.892 30.8301 9.80291 34.576 5.97455C37.8896 2.5835 43.6921 3.67553 48.2976 8.23858C48.8949 8.82833 49.4721 9.47805 50.0219 10.1852C50.3367 10.5901 50.6341 11.0024 50.9115 11.4222C54.8973 17.3797 55.4071 24.679 51.9086 28.255H51.9061Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9144 11.418L47.9507 12.4951L45.1094 9.50133L48.3005 8.23438C48.8978 8.82412 49.475 9.47385 50.0248 10.181C50.3396 10.5859 50.637 10.9982 50.9144 11.418Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6068 4.33594L35.332 6.34758",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4871 5.04688L37.4922 6.89858",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8256 6.32031L39.5508 8.33445",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1615 20.5859L47.8867 22.6001",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1537 23.0469L47.8789 25.061",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5717 25.5L47.2969 27.5141",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2566 8.29688L42.1367 10.3135",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9115 11.4844L44.6367 13.4985",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6458 29.2499C55.1402 26.5097 55.4685 18.851 51.3791 12.1437C47.2898 5.43636 40.3313 2.2203 35.8369 4.96043C31.3426 7.70056 31.0143 15.3592 35.1037 22.0666C39.193 28.7739 46.1515 31.99 50.6458 29.2499Z",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2552 30.0545C53.7495 27.3144 54.0779 19.6557 49.9885 12.9484C45.8991 6.24105 38.9407 3.02499 34.4463 5.76512C29.952 8.50525 29.6237 16.1639 33.713 22.8713C37.8024 29.5786 44.7609 32.7947 49.2552 30.0545Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1295 28.2182C51.9428 25.8934 52.2204 19.3938 48.7496 13.701C45.2788 8.00829 39.374 5.27808 35.5607 7.60295C31.7475 9.92782 31.4699 16.4274 34.9407 22.1201C38.4114 27.8129 44.3163 30.5431 48.1295 28.2182Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M48.1295 28.2182C51.9428 25.8934 52.2204 19.3938 48.7496 13.701C45.2788 8.00829 39.374 5.27808 35.5607 7.60295C31.7475 9.92782 31.4699 16.4274 34.9407 22.1201C38.4114 27.8129 44.3163 30.5431 48.1295 28.2182Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1295 28.2182C51.9428 25.8934 52.2204 19.3938 48.7496 13.701C45.2788 8.00829 39.374 5.27808 35.5607 7.60295C31.7475 9.92782 31.4699 16.4274 34.9407 22.1201C38.4114 27.8129 44.3163 30.5431 48.1295 28.2182Z",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6556 23.3652C32.5948 18.1449 31.8777 11.2779 35.0538 8.03175C35.1563 7.92679 35.2612 7.82933 35.3687 7.73438C35.0588 7.94179 34.7664 8.18168 34.494 8.46156C31.3179 11.7102 32.0351 18.5747 36.0959 23.795C40.0267 28.8478 45.6493 30.5096 48.8879 27.6659C45.5918 29.8824 40.369 28.1407 36.6581 23.3652H36.6556Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9799 23.8599L40.2852 22.9553L39.723 23.6975L39.0507 22.8228L39.613 22.0807L38.8933 21.1436L38.3311 21.8857L37.6588 21.0111L38.2211 20.2689L37.4764 19.3019C35.4623 16.6805 34.8775 14.2115 36.9691 11.4477C39.0607 8.68389 40.7275 9.50104 42.3843 11.6551L42.9716 12.4198L41.0049 15.0187L40.2852 14.0816C39.7205 13.3469 39.1107 12.5822 38.481 13.4144C37.8513 14.2465 38.396 15.1311 38.9833 15.8958L40.2677 17.5651L41.4372 16.0208L42.1094 16.8954L40.9399 18.4397L41.6596 19.3768L42.8291 17.8325L43.5013 18.7071L42.3318 20.2514L43.5563 21.8433C44.216 22.7004 44.8458 23.2552 45.4405 22.468C46.0353 21.6808 45.4805 20.8412 44.8932 20.0765L44.3885 19.4218L46.3551 16.8229L46.68 17.2452C48.3343 19.3993 48.9965 21.7633 46.9624 24.4522C44.8708 27.2135 42.9491 26.4213 40.9799 23.8624V23.8599Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3979 24.1609L39.7032 23.2562L39.1409 23.9984L38.4687 23.1238L39.031 22.3816L38.3113 21.4445L37.749 22.1867L37.0768 21.3121L37.6391 20.5699L36.8944 19.6028C34.8802 16.9814 34.2955 14.5125 36.3871 11.7487C38.3987 9.0898 40.1455 9.802 41.8023 11.9561L42.3895 12.7208L40.4229 15.3196L39.7032 14.3825C39.1384 13.6479 38.5287 12.8832 37.899 13.7153C37.2592 14.5625 37.814 15.4321 38.4012 16.1968L39.6857 17.8661L40.8552 16.3217L41.5274 17.1963L40.3579 18.7407L41.0776 19.6778L42.2471 18.1334L42.9193 19.0081L41.7498 20.5524L42.9743 22.1442C43.634 23.0014 44.2637 23.5561 44.8585 22.769C45.4757 21.9518 44.8985 21.1422 44.3112 20.3775L43.8064 19.7228L45.7731 17.1239L46.098 17.5462C47.7522 19.7003 48.4145 22.0643 46.3803 24.7531C44.3462 27.442 42.3671 26.7223 40.3979 24.1634V24.1609Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.249893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2384 30.7992C26.9871 24.6506 26.6861 17.63 22.5662 15.1181C18.4463 12.6063 12.0675 15.5544 8.31884 21.703C4.57016 27.8515 4.87111 34.8722 8.99103 37.384C13.111 39.8959 19.4897 36.9478 23.2384 30.7992Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M7.8355 36.4681C11.2648 39.9752 17.6055 38.248 21.9923 32.6082C26.3791 26.9706 27.1557 19.5532 23.7218 16.0438C20.6843 12.9352 15.3652 13.9363 11.1433 18.1192C10.5959 18.6598 10.0667 19.2554 9.56273 19.9037C9.27409 20.2748 9.00149 20.6528 8.74722 21.0376C5.09347 26.4987 4.62616 33.19 7.83321 36.4681H7.8355Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.0356L11.4668 22.0229L14.0714 19.2786L11.1461 18.1172C10.5986 18.6578 10.0695 19.2534 9.56551 19.9017C9.27687 20.2728 9.00427 20.6508 8.75 21.0356Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 14.5469L23.0333 16.3932",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 15.2031L21.0486 16.8983",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 16.3672L19.1583 18.2135",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76953 29.4453L11.5216 31.2917",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78125 31.6953L11.5333 33.5417",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 33.9531L12.0646 35.7995",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1797 18.1719L16.792 20.0205",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75391 21.1016L14.506 22.9456",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2384 30.7992C26.9871 24.6506 26.6861 17.63 22.5662 15.1181C18.4463 12.6063 12.0675 15.5544 8.31884 21.703C4.57016 27.8515 4.87111 34.8722 8.99103 37.384C13.111 39.8959 19.4897 36.9478 23.2384 30.7992Z",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5157 31.5414C28.2644 25.3928 27.9635 18.3722 23.8435 15.8603C19.7236 13.3485 13.3449 16.2966 9.59618 22.4452C5.8475 28.5937 6.14845 35.6144 10.2684 38.1262C14.3883 40.6381 20.7671 37.69 24.5157 31.5414Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3882 30.8469C26.5698 25.6284 26.3153 19.6703 22.8198 17.5391C19.3242 15.4079 13.9112 17.9107 10.7296 23.1292C7.54798 28.3477 7.80246 34.3058 11.298 36.437C14.7936 38.5682 20.2065 36.0654 23.3882 30.8469Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M23.3882 30.8469C26.5698 25.6284 26.3153 19.6703 22.8198 17.5391C19.3242 15.4079 13.9112 17.9107 10.7296 23.1292C7.54798 28.3477 7.80246 34.3058 11.298 36.437C14.7936 38.5682 20.2065 36.0654 23.3882 30.8469Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3882 30.8469C26.5698 25.6284 26.3153 19.6703 22.8198 17.5391C19.3242 15.4079 13.9112 17.9107 10.7296 23.1292C7.54798 28.3477 7.80246 34.3058 11.298 36.437C14.7936 38.5682 20.2065 36.0654 23.3882 30.8469Z",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8148 31.9927C25.5372 27.2073 26.1947 20.9123 23.2831 17.9367C23.1892 17.8405 23.093 17.7511 22.9945 17.6641C23.2786 17.8542 23.5466 18.0741 23.7963 18.3307C26.7078 21.3086 26.0504 27.6013 22.3279 32.3867C18.7246 37.0186 13.5704 38.5419 10.6016 35.9351C13.6231 37.967 18.4107 36.3703 21.8125 31.9927H21.8148Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3659 32.9876C10.5013 30.5227 11.1083 28.3557 12.6248 26.3811L12.9226 25.9939L14.7254 28.3763L14.2627 28.9765C13.7243 29.6775 13.1952 30.4197 13.761 31.1687C14.3062 31.8903 14.8835 31.3841 15.4882 30.596L16.6107 29.1368L15.5386 27.7212L16.1548 26.9194L17.2269 28.3351L17.8866 27.476L16.8146 26.0604L17.4308 25.2586L18.5028 26.6743L19.6803 25.1441C20.2186 24.4431 20.7272 23.6459 20.1407 22.8693C19.5543 22.0928 19.0045 22.8098 18.4868 23.481L17.8271 24.34L16.0243 21.9576L16.5626 21.2567C18.0791 19.282 19.6826 18.6292 21.5266 21.0665C23.444 23.5978 22.908 25.8611 21.0616 28.2664L20.379 29.1529L20.8944 29.8332L20.2782 30.635L19.7628 29.9546L19.103 30.8137L19.6184 31.494L19.0022 32.2958L18.4868 31.6154L17.85 32.4447C16.0472 34.7904 14.2833 35.5189 12.3659 32.9853V32.9876Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9089 33.2688C11.0442 30.804 11.6513 28.6369 13.1678 26.6623L13.4656 26.2752L15.2684 28.6576L14.8056 29.2577C14.2673 29.9587 13.7381 30.7009 14.304 31.45C14.8492 32.1716 15.4264 31.6653 16.0312 30.8773L17.1537 29.4181L16.0816 28.0024L16.6978 27.2006L17.7699 28.6163L18.4296 27.7573L17.3575 26.3416L17.9737 25.5398L19.0458 26.9555L20.2233 25.4253C20.7616 24.7243 21.2701 23.9272 20.6837 23.1506C20.1064 22.3878 19.5475 23.091 19.0298 23.7622L18.37 24.6213L16.5672 22.2389L17.1056 21.5379C18.622 19.5633 20.2256 18.9104 22.0696 21.3478C23.987 23.8791 23.4509 26.1423 21.6046 28.5476L20.9219 29.4341L21.4374 30.1145L20.8211 30.9162L20.3057 30.2359L19.646 31.0949L20.1614 31.7753L19.5452 32.577L19.0298 31.8967L18.393 32.7259C16.5901 35.0717 14.8263 35.8001 12.9089 33.2665V33.2688Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.229075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2745 61.2889C32.0568 55.3723 30.3267 47.5097 24.4101 43.7274C18.4935 39.945 10.6309 41.6752 6.84858 47.5917C3.06621 53.5083 4.79635 61.3709 10.7129 65.1533C16.6295 68.9356 24.4921 67.2055 28.2745 61.2889Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M28.2745 61.2889C32.0568 55.3723 30.3267 47.5097 24.4101 43.7274C18.4935 39.945 10.6309 41.6752 6.84858 47.5917C3.06621 53.5083 4.79635 61.3709 10.7129 65.1533C16.6295 68.9356 24.4921 67.2055 28.2745 61.2889Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6836 42.0469V43.9643",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 42.6484V45.3739",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 43.5391V47.0013",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55859 45.3906V48.1106",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7578 44.0312V46.7512",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4336 45.4062V46.9922",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9687 41.7999C18.0154 41.6931 17.0485 41.6903 16.0898 41.7999V67.0573C17.0431 67.1696 18.01 67.1696 18.9687 67.0655V41.7999Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2745 61.2889C32.0568 55.3723 30.3267 47.5097 24.4101 43.7274C18.4935 39.945 10.6309 41.6752 6.84858 47.5917C3.06621 53.5083 4.79635 61.3709 10.7129 65.1533C16.6295 68.9356 24.4921 67.2055 28.2745 61.2889Z",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1788 57.2336C31.0419 50.2645 26.092 43.9153 19.123 43.0522C12.154 42.1891 5.80478 47.139 4.94168 54.108C4.07859 61.077 9.02842 67.4262 15.9975 68.2893C22.9665 69.1524 29.3157 64.2026 30.1788 57.2336Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2617 57.088C29.0354 51.1796 24.8729 45.7628 18.9645 44.9891C13.0562 44.2155 7.63932 48.378 6.86567 54.2863C6.09201 60.1947 10.2545 65.6115 16.1629 66.3852C22.0712 67.1589 27.4881 62.9964 28.2617 57.088Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M28.2617 57.088C29.0354 51.1796 24.8729 45.7628 18.9645 44.9891C13.0562 44.2155 7.63932 48.378 6.86567 54.2863C6.09201 60.1947 10.2545 65.6115 16.1629 66.3852C22.0712 67.1589 27.4881 62.9964 28.2617 57.088Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2617 57.088C29.0354 51.1796 24.8729 45.7628 18.9645 44.9891C13.0562 44.2155 7.63932 48.378 6.86567 54.2863C6.09201 60.1947 10.2545 65.6115 16.1629 66.3852C22.0712 67.1589 27.4881 62.9964 28.2617 57.088Z",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1535 63.5678C19.434 67.2081 12.6602 66.3343 9.0199 61.6148C7.56817 59.733 6.83683 57.5253 6.77931 55.3203C6.69987 57.7389 7.42574 60.1987 9.0199 62.264C12.6602 66.9835 19.4367 67.8572 24.1535 64.217C26.9912 62.0284 28.4347 58.7031 28.3471 55.3778C28.243 58.484 26.805 61.5217 24.1535 63.5678Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3171 54.1339L13.1197 53.3204L12.4185 52.6274L13.1936 51.8413L13.8948 52.5343L14.7275 51.6934L14.0263 51.0004L14.8015 50.2143L15.5027 50.9073L16.3628 50.0362C18.691 47.6778 20.9316 47.0369 23.542 49.6144C26.0538 52.0933 25.4676 54.1778 23.5557 56.1143L22.8764 56.8018L20.4194 54.3777L21.2521 53.5368C21.904 52.8767 22.5833 52.1618 21.7972 51.3866C21.011 50.6114 20.2194 51.2442 19.5401 51.9317L18.0583 53.4327L19.5182 54.8735L18.7431 55.6596L17.2831 54.2188L16.4504 55.0597L17.9104 56.5005L17.1352 57.2866L15.6753 55.8459L14.2619 57.2784C13.5004 58.0509 13.0156 58.7932 13.7606 59.5272C14.533 60.2887 15.2534 59.6149 15.9327 58.9274L16.5134 58.3385L18.9704 60.7626L18.5951 61.1406C16.6832 63.0771 14.5413 63.8167 11.9994 61.3077C9.38899 58.7302 10.0436 56.4403 12.3144 54.1367L12.3171 54.1339Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5944 54.7277L13.397 53.9142L12.6958 53.2212L13.471 52.435L14.1722 53.128L15.0049 52.2871L14.3037 51.5941L15.0788 50.808L15.78 51.501L16.6401 50.63C18.9684 48.2716 21.209 47.6306 23.8193 50.2081C26.3311 52.687 25.7449 54.7715 23.833 56.7081L23.1537 57.3956L20.6967 54.9715L21.5294 54.1305C22.1813 53.4704 22.8606 52.7555 22.0745 51.9803C21.2884 51.2052 20.4968 51.8379 19.8175 52.5254L18.3356 54.0265L19.7956 55.4672L19.0204 56.2534L17.5605 54.8126L16.7278 55.6535L18.1877 57.0943L17.4125 57.8804L15.9526 56.4396L14.5392 57.8722C13.7777 58.6446 13.2929 59.3869 14.038 60.121C14.783 60.8551 15.5308 60.2086 16.2101 59.5211L16.7908 58.9322L19.2478 61.3563L18.8725 61.7343C16.9606 63.6709 14.8186 64.4104 12.2767 61.9014C9.66634 59.3239 10.321 57.034 12.5917 54.7304L12.5944 54.7277Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.273911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7528 47.7691C74.203 42.372 72.6248 35.1998 67.2277 31.7495C61.8306 28.2993 54.6584 29.8775 51.2082 35.2746C47.7579 40.6717 49.3361 47.8439 54.7332 51.2941C60.1303 54.7444 67.3025 53.1661 70.7528 47.7691Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M70.7528 47.7691C74.203 42.372 72.6248 35.1998 67.2277 31.7495C61.8306 28.2993 54.6584 29.8775 51.2082 35.2746C47.7579 40.6717 49.3361 47.8439 54.7332 51.2941C60.1303 54.7444 67.3025 53.1661 70.7528 47.7691Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3555 30.2344V31.9834",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7812 30.7969V33.283",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1445 31.6016V34.7598",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7734 33.2891V35.7702",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5547 32.0391V34.5202",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0781 33.3047V34.7514",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2667 30.0115C61.3971 29.9141 60.5151 29.9116 59.6406 30.0115V53.0512C60.5101 53.1536 61.3921 53.1536 62.2667 53.0586V30.0115Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7528 47.7691C74.203 42.372 72.6248 35.1998 67.2277 31.7495C61.8306 28.2993 54.6584 29.8775 51.2082 35.2746C47.7579 40.6717 49.3361 47.8439 54.7332 51.2941C60.1303 54.7444 67.3025 53.1661 70.7528 47.7691Z",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4897 44.0905C73.277 37.7334 68.7618 31.9417 62.4047 31.1544C56.0475 30.3671 50.2558 34.8823 49.4685 41.2394C48.6812 47.5965 53.1964 53.3882 59.5535 54.1756C65.9107 54.9629 71.7024 50.4477 72.4897 44.0905Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7405 43.9454C71.4463 38.5558 67.6492 33.6146 62.2597 32.9089C56.8701 32.2031 51.9289 36.0002 51.2231 41.3897C50.5174 46.7793 54.3144 51.7205 59.704 52.4263C65.0936 53.132 70.0348 49.335 70.7405 43.9454Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M70.7405 43.9454C71.4463 38.5558 67.6492 33.6146 62.2597 32.9089C56.8701 32.2031 51.9289 36.0002 51.2231 41.3897C50.5174 46.7793 54.3144 51.7205 59.704 52.4263C65.0936 53.132 70.0348 49.335 70.7405 43.9454Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7405 43.9454C71.4463 38.5558 67.6492 33.6146 62.2597 32.9089C56.8701 32.2031 51.9289 36.0002 51.2231 41.3897C50.5174 46.7793 54.3144 51.7205 59.704 52.4263C65.0936 53.132 70.0348 49.335 70.7405 43.9454Z",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9946 49.867C62.6895 53.1877 56.5105 52.3906 53.1898 48.0855C51.8656 46.369 51.1984 44.3551 51.146 42.3438C51.0735 44.55 51.7356 46.7938 53.1898 48.6777C56.5105 52.9828 62.692 53.7799 66.9946 50.4592C69.5832 48.4628 70.8999 45.4295 70.82 42.3962C70.725 45.2296 69.4133 48.0006 66.9946 49.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7962 37.2777L62.6233 37.9149L63.1704 37.2028L63.97 37.8174L63.4228 38.5295L64.2798 39.1867L64.827 38.4746L65.6266 39.0892L65.0794 39.8013L65.9639 40.481C68.36 42.3224 69.1946 44.2788 67.1532 46.9324C65.1918 49.4859 63.2404 49.1886 61.2715 47.6769L60.5719 47.1397L62.4908 44.6436L63.3478 45.3008C64.0175 45.8155 64.7421 46.3502 65.3567 45.5506C65.9714 44.7511 65.3093 44.1064 64.6096 43.5692L63.083 42.3949L61.9436 43.8791L61.1441 43.2644L62.2834 41.7802L61.4264 41.1231L60.2871 42.6073L59.4875 41.9926L60.6269 40.5084L59.1727 39.3891C58.3881 38.7869 57.661 38.4321 57.0813 39.1892C56.5017 39.9463 57.1688 40.5509 57.8684 41.0881L58.4681 41.5479L56.5491 44.044L56.1644 43.7491C54.1955 42.235 53.286 40.3785 55.2699 37.7975C57.3087 35.1439 59.4575 35.4788 61.7962 37.2777Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3001 37.7543L62.1272 38.3915L62.6744 37.6794L63.4739 38.294L62.9267 39.0061L63.7837 39.6632L64.3309 38.9511L65.1305 39.5658L64.5833 40.2779L65.4678 40.9575C67.864 42.799 68.6985 44.7554 66.6571 47.4089C64.6957 49.9625 62.7443 49.6652 60.7754 48.1535L60.0758 47.6163L61.9947 45.1202L62.8518 45.7773C63.5214 46.292 64.246 46.8267 64.8606 46.0272C65.4753 45.2276 64.8132 44.583 64.1136 44.0458L62.5869 42.8715L61.4475 44.3556L60.648 43.741L61.7874 42.2568L60.9303 41.5997L59.791 43.0838L58.9914 42.4692L60.1308 40.985L58.6766 39.8656C57.892 39.2635 57.1649 38.9087 56.5853 39.6657C56.0056 40.4228 56.6727 41.0275 57.3723 41.5647L57.972 42.0244L56.0531 44.5205L55.6683 44.2257C53.6994 42.7115 52.7899 40.8551 54.7738 38.274C56.8126 35.6205 58.9614 35.9553 61.3001 37.7543Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.24986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4644 75.539C55.9404 72.2604 60.2201 65.5418 58.0234 60.5327C55.8266 55.5236 47.9853 54.1208 40.5092 57.3994C33.0332 60.6781 28.7535 67.3966 30.9502 72.4057C33.147 77.4148 40.9883 78.8176 48.4644 75.539Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8316 73.9921C55.3076 70.7135 59.5873 63.9949 57.3906 58.9858C55.1938 53.9767 47.3525 52.5739 39.8764 55.8526C32.4004 59.1312 28.1207 65.8497 30.3174 70.8588C32.5142 75.8679 40.3555 77.2708 47.8316 73.9921Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2293 72.6206C53.5733 69.8385 57.2049 64.1374 55.3408 59.8868C53.4767 55.6363 46.8228 54.4459 40.4789 57.2281C34.135 60.0102 30.5033 65.7114 32.3674 69.9619C34.2315 74.2124 40.8854 75.4028 47.2293 72.6206Z",
    fill: "#CFB64D",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M55.2846 59.764C45.749 58.844 37.088 65.3574 32.324 69.8668C31.8577 68.7577 31.7669 67.5327 32.0089 66.2799C32.5634 63.3812 34.9127 60.3262 38.5954 58.1836C43.5157 55.3201 49.2829 54.9773 52.7665 57.0619C53.4899 57.4929 54.11 58.0298 54.6091 58.6676C54.8788 59.0154 55.1056 59.3834 55.2846 59.7666V59.764Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M52.7693 57.0594C44.3503 56.7645 36.7153 62.0604 32.0117 66.2799C32.5663 63.3812 34.9155 60.3262 38.5982 58.1836C43.5185 55.3201 49.2857 54.9773 52.7693 57.0619V57.0594Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2293 72.6206C53.5733 69.8385 57.2049 64.1374 55.3408 59.8868C53.4767 55.6363 46.8228 54.4459 40.4789 57.2281C34.135 60.0102 30.5033 65.7114 32.3674 69.9619C34.2315 74.2124 40.8854 75.4028 47.2293 72.6206Z",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M38.959 58.8219C44.9001 55.3661 52.0689 55.5804 54.9727 59.3034C55.0659 59.4219 55.1542 59.5454 55.2348 59.6689C55.0634 59.321 54.8567 58.9858 54.6072 58.6657C51.7034 54.9427 44.5347 54.7284 38.5935 58.1842C32.8439 61.5291 30.3509 67.0897 32.8313 70.8202C31.0063 67.1174 33.527 61.9828 38.959 58.8219Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1117 63.7344L39.0923 63.1345L38.4142 62.5472L39.362 61.9674L40.04 62.5548L41.0559 61.9322L40.3778 61.3448L41.3256 60.7651L42.0036 61.3524L43.0522 60.7096C45.893 58.9704 48.4212 58.5847 50.9444 60.7701C53.3718 62.8749 52.4669 64.4931 50.1327 65.9223L49.3034 66.429L46.9315 64.3721L47.9473 63.7495C48.7413 63.2631 49.5731 62.7337 48.8144 62.0733C48.0557 61.4129 47.1105 61.8717 46.2812 62.3808L44.4713 63.4899L45.8829 64.7124L44.9351 65.2922L43.5236 64.0697L42.5078 64.6923L43.9193 65.9148L42.9716 66.4945L41.56 65.272L39.8359 66.3282C38.9057 66.8978 38.2831 67.4599 39.0015 68.0825C39.7199 68.7051 40.6198 68.2338 41.4491 67.7271L42.1599 67.2911L44.5318 69.3479L44.0756 69.6277C41.7415 71.0569 39.3091 71.5258 36.8539 69.3958C34.3988 67.2659 35.339 65.4283 38.1117 63.7294V63.7344Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0084 63.0625L38.9889 62.4626L38.3109 61.8753L39.2586 61.2956L39.9367 61.8829L40.9525 61.2603L40.2745 60.673L41.2222 60.0932L41.9003 60.6805L42.9489 60.0378C45.7896 58.2985 48.3179 57.9129 50.841 60.0983C53.2684 62.203 52.3635 63.8213 50.0294 65.2505L49.2001 65.7571L46.8282 63.7003L47.844 63.0777C48.638 62.5912 49.4698 62.0618 48.7111 61.4014C47.9372 60.7309 47.0071 61.1998 46.1778 61.709L44.368 62.818L45.7796 64.0406L44.8318 64.6203L43.4202 63.3978L42.4044 64.0204L43.816 65.2429L42.8682 65.8227L41.4566 64.6001L39.7325 65.6563C38.8024 66.226 38.1798 66.7881 38.8982 67.4107C39.6166 68.0333 40.5164 67.5619 41.3457 67.0553L42.0566 66.6192L44.4285 68.676L43.9723 68.9558C41.6381 70.385 39.2057 70.8539 36.7506 68.7239C34.2274 66.536 35.2357 64.7564 38.0084 63.0575V63.0625Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.252065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Sur3);
export default __webpack_public_path__ + "static/media/3sur3.44491340ea383f49540779417c88a81c.svg";
export { ForwardRef as ReactComponent };